<template>
    <div class="BackorderTable Table">
    <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tbody>
            <tr class="TableHead">
                <th scope="col" class="BTName">{{this.risorse["Nome"]}}</th>
                <th scope="col" class="BTStock">{{this.risorse["TabVarStock"]}}</th>
                <th scope="col" class="BTColor">{{this.risorse["TabVarColore"]}}</th>
                <th scope="col" class="BTSize">{{this.risorse["TabVarTaglia"]}}</th>
                <th sope="col" class="BTColor">{{this.risorse["TabVarDtNewArr"]}}</th>
                <th scope="col" class="BTUnitPrice">{{this.risorse["TabVarPrezzoUn"]}}</th>
                <th scope="col" class="BTQty">{{this.risorse["quantita"]}}</th> 
                <th scope="col" class="BTSubtotal">{{this.risorse["TabVarSub"]}}</th> 
                <!--<th scope="col" class="BTAddToBasket">{{this.risorse["backorderTabDescr"]}}</th>-->
            </tr>
            <tr class="TableRow MyFontColorPers" 
                :class="{ InStock: this.inStockBack(riga), FewPieces: this.fewPiecesBack(riga), OutOfStock: this.outOfStockBack(riga)}" 
                v-for="riga in this.backOrderList" :key="riga.CodiceArticolo"
            >
                <td class="BTName">
                    <div>
                        <p>{{riga.IdAnaart}}</p>
                        <p>
                            <router-link :to="{name: 'ModelDetail', params:{idCatalog: riga.CodiceCatalogo, idCategory: riga.CodiceCategoria ,idModel: riga.IdAnaartPadre}}">
                                {{riga.Descr}}
                            </router-link>
                        </p>
                    </div>
                </td>
                <td class="BTStock">
                    <span class="AvailibilityIcon">&nbsp;</span>
                </td>
                <td class="BTColor">
                    <span>{{riga.DescrColore}}</span>
                </td>
                <td class="BTSize">
                    <span>{{riga.DescrTaglia}}</span>
                </td>
                <td class="BTColor">
                    <span>{{ this.formatDateNoOre(riga.DtNuoviArrivi) ?? '.-' }}</span>
                </td>
                <td class="BTUnitPrice">
                    <span>€ {{this.FixPrezzo(riga)}}</span>
                </td>
                <td class="BTQty">
                    <span>{{riga.QuantitaResidua}}</span>
                </td>
                <td class="BTSubtotal">
                    <span>€ {{this.calculateTotal(riga)}}</span>
                </td>
                <!--<td class="BTAddToBasket">
                    <div v-if="riga.Shoppable" class="Button Small CustomColor Iconed AddShop"><a @click="this.addToCart(riga)">{{ this.risorse["AggiungiCarrello"] }}</a></div>
                    <div v-else class="Button Small CustomColor Iconed AddShop"><a class="Myclass">{{ this.risorse["AggiungiCarrello"] }}</a></div>
                </td>-->
            </tr>
        </tbody>
    </table>
</div>
</template>
<script>
import {risorseMixin,CalcoloSoglieMixin, dateMixin} from "@/mixin.js";
import CartService from '@/services/cart.service.js';
import AddCartResponse from '@/models/AddCartResponse.model.js';

export default {
    name: "BackorderTable",
    mixins:[risorseMixin,CalcoloSoglieMixin,dateMixin],
    props:{
        backOrderList: Array
    },
    emits:['reload'],
    methods:{
        calculateTotal(riga){
            let v = parseFloat(riga.Prezzo.replace(',','.')) * parseFloat(riga.QuantitaResidua);
            return v.toFixed(2).toString().replace('.',',');
        },
        FixPrezzo(riga){
            let v = parseFloat(riga.Prezzo.replace(',','.')).toFixed(2);
            return v.toString().replace('.',',');
        },
        addToCart: function(riga){
            this.$store.commit('updateRow', {
                CodiceArticolo: riga.IdAnaart,
                Quantita: riga.QuantitaResidua,
                PrezzoNetto: parseFloat(riga.Prezzo.replace(',','.')).toFixed(2), 
                PrezzoListino: parseFloat(riga.Prezzo.replace(',','.')).toFixed(2),
                Catalogo: riga.CodiceCatalogo,
                DescrizioneArticolo: riga.Descr,
                DescrizioneTaglia: riga.DescrTaglia,
                DescrizioneColore: riga.DescrColore,
                UrlImmagine: riga.UrlImmagine,
                Valuta: this.codiceValuta,
                IsBackorder: 1
            });
            if(!this.$store.getters.getCarrelloTmp || this.$store.getters.getCarrelloTmp.Righe.length == 0){
                this.showModal = true; 
                this.responseCart = 2;
                return;
            }
            this.$store.dispatch({
                type: 'setCarrello',
                token: this.$store.getters.getToken
            }).then(
                (data) => {
                    if(data){
                        CartService.getCartByUsername(this.$store.getters.getToken).then(
                            (data) => {
                                if(data){
                                    let responseCart = new AddCartResponse();
                                    Object.assign(responseCart, data);
                                    if(responseCart.Status == 1){
                                        this.$store.commit('resetCarrelloTmp');
                                        this.$store.commit('updateCarrello', responseCart.Carrello);
                                        this.$store.commit('setChkSeasonalOrders',(responseCart.Carrello?.ChkSeasonalOrder ?? false));
                                        this.responseCart = 1;
                                    }
                                    this.$emit('reload');
                                }
                            }
                        );
                        this.showModal = true; 
                    }
                    else{
                        this.showModal = true; 
                        this.responseCart = -1;
                    }
                }
            );
        }
    }
}
</script>

<style scoped>
.MyFontColorPers p {
    color: black !important;
}

.MyFontColorPers span{
    color: black !important;
} 
.Myclass{
    background-color: lightgray !important;
    color: white !important;
}
</style>

